import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useEffect } from "preact/hooks"
import SubmitButton from "./elements/SubmitButton"
import Product from "./Product"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    useEffect(() => {
        setTimeout(() => {
            window.QuickAdd.connectedCallback()

            const productCards = document.querySelectorAll("product-card")
            productCards.forEach(card => {
                if (!card.swiper && !card.initialized) {
                    const productCardInstance = new ProductCard()
                    productCardInstance.connectedCallback()
                    card.initialized = true
                }
            })
        }, 0)

        const isEmpty = !products?.hits?.length && !keywords?.hits?.length

        if (isEmpty) {
            const element = document.querySelector('.search-recommended-items')
            if (element) {
                document.querySelectorAll('.search-recommended-items').forEach(function(el) {
                    el.classList.remove('hidden')
                })
                
            }
        } else {
            const element = document.querySelector('.search-recommended-items')
            if (element) {
                document.querySelectorAll('.search-recommended-items').forEach(function(el) {
                    el.classList.add('hidden')
                })
            }
        }
    }, [products])

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="autocomplete-content w-full flex"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="lg:flex">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class="autocomplete-keywords"
                        >
                            <div class="autocomplete-title color-text">hot searches</div>
                            <div class="ns-d-flex ns-flex-column gap-2">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="autocomplete-products w-full">
                            <div class="autocomplete-title color-text">best sellers</div>

                            <div class="autocomplete-products__grid grid grid-cols-2 lg:grid-cols-4 gap-grid color-bg-3 border border-solid color-border-dark">
                                {products?.hits?.map(hit => {
                                    return (
                                        <Product
                                            product={hit}
                                            context={'search'}
                                            key={hit.productId}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    class="color-text"
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
